<div class="pt-xl">
    <app-simple-input [label]="'Email'"
                      type="email"
                      [placeHolder]="'Es: info@fivelab.it'"
                      [control]="registerForm.get('email') | formControlConverter"></app-simple-input>
</div>

<div class="pt-xl">
    <app-simple-input [label]="'Nome'"
                      [placeHolder]="'Es: Mario'"
                      [control]="registerForm.get('name') | formControlConverter"></app-simple-input>
</div>

<div class="pt-xl">
    <app-simple-input [label]="'Cognome'"
                      [placeHolder]="'Es: Rossi'"
                      [control]="registerForm.get('lastName') | formControlConverter"></app-simple-input>
</div>
